__webpack_require__.p = "/wot-project-2024-2025-part1-Grassi-Massari-Santantonio/";